import type { PropsWithChildren } from "react";
import { Platform } from "react-native";
import * as Application from "expo-application";

import { posthog } from "@/shared/lib/posthog";
import { UpdateModal } from "./update-modal";

function isVersionBelow(current: string, minimum: string): boolean {
  const parse = (v: string) => v.split(".").map(Number);
  const [cMaj, cMin, cPatch] = parse(current);
  const [mMaj, mMin, mPatch] = parse(minimum);
  if (cMaj !== mMaj) return cMaj < mMaj;
  if (cMin !== mMin) return cMin < mMin;
  return cPatch < mPatch;
}

function UpdateGateInner({ children }: PropsWithChildren) {
  const minimumVersion = posthog?.getFeatureFlagPayload("minimum_version");
  const currentVersion = Application.nativeApplicationVersion;

  const needsUpdate =
    Platform.OS !== "web" &&
    typeof minimumVersion === "string" &&
    !!currentVersion &&
    isVersionBelow(currentVersion, minimumVersion);

  return (
    <>
      {children}
      <UpdateModal visible={needsUpdate} />
    </>
  );
}

export function UpdateGate({ children }: PropsWithChildren) {
  if (!posthog) return <>{children}</>;
  return <UpdateGateInner>{children}</UpdateGateInner>;
}
